import React from 'react'
import { useCrisp } from 'plugins/crisp'
import { Product, ProductsDocument } from 'types/domain'
import { SiteLayout, SiteSEO, StructuredData } from 'components/site'
import { brandingUrl } from 'config/constants'
import Pricing from 'modules/Site/Pricing'
import { GetStaticProps } from 'next'
import { initializeApollo } from 'plugins/apollo'

type Props = {
  products: Product[]
}

const pricingTitle = '价格套餐 - 浩客HowXM官网 - 数字化系统必备的应用内调研、评价、通知工具，支持免费试用'

const buildProductSchema = (products: Product[]) =>
  products.map((product) => ({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `浩客HowXM ${product.name}`,
    brand: { '@type': 'Brand', name: '浩客HowXM' },
    offers: (product.prices ?? []).map((price) => ({
      '@type': 'Offer',
      priceCurrency: 'CNY',
      price: (price.unitAmount ?? 0) / 100,
      url: `${brandingUrl}/pricing`,
    })),
  }))

function Price({ products }: Props) {
  useCrisp()
  return (
    <SiteLayout>
      <SiteSEO
        title={pricingTitle}
        description="浩客HowXM 提供免费套餐与多档付费套餐，支持免费注册试用。在 Web、App、小程序中嵌入问卷、NPS 调研与通知，按需选择适合团队的体验管理方案。"
      />
      <StructuredData data={buildProductSchema(products)} />
      <Pricing products={products} />
    </SiteLayout>
  )
}

export default Price

export const getStaticProps: GetStaticProps<{
  products: Product[]
}> = async () => {
  try {
    const { data } = await initializeApollo().query({
      query: ProductsDocument,
    })
    const products = data?.products ?? []
    return {
      props: {
        products,
      },
    }
  } catch (error) {
    return {
      props: {
        products: [],
      },
    }
  }
}
